/* eslint-disable react/no-danger */
import React, { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as IconInfo } from '../assets/icons/info.svg';

const StyledBanner = styled.div`
    background: #222222;
    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.24);
    color: #fff;
    display: grid;
    place-items: center;
    font-size: 14px;
`;

const StyledBannerContent = styled.div`
    width: 100%;
    max-width: 1050px;
    padding: 15px 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    color: #fff;

    > *:first-child {
        margin-right: 10px;
    }

    p {
        color: #fff;
        margin: 0 0 8px 0;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

const StyledHtml = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
`;

function createMarkup(content) {
    return { __html: content };
}

interface BannerProps {
    stockistsMessage?: string;
    showStockistsMessage?: boolean;
}
const Banner: FC<BannerProps> = ({ stockistsMessage, showStockistsMessage = false }) => {
    if (stockistsMessage && showStockistsMessage) {
        return (
            <StyledBanner className="stockist-banner-msg">
                <StyledBannerContent>
                    <IconInfo />
                    <StyledHtml dangerouslySetInnerHTML={createMarkup(stockistsMessage)} />
                </StyledBannerContent>
            </StyledBanner>
        );
    }

    return null;
};

export default Banner;
